/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GuildsGuildIdIndexRouteImport } from './routes/guilds/$guildId/index'
import { Route as GuildsGuildIdWelcomeRouteImport } from './routes/guilds/$guildId/welcome'
import { Route as GuildsGuildIdSpamQueueRouteImport } from './routes/guilds/$guildId/spam-queue'
import { Route as GuildsGuildIdSpamRouteImport } from './routes/guilds/$guildId/spam'
import { Route as GuildsGuildIdReactionRolesRouteImport } from './routes/guilds/$guildId/reaction-roles'
import { Route as GuildsGuildIdPurgeRouteImport } from './routes/guilds/$guildId/purge'
import { Route as GuildsGuildIdPollsRouteImport } from './routes/guilds/$guildId/polls'
import { Route as GuildsGuildIdMembersRouteImport } from './routes/guilds/$guildId/members'
import { Route as GuildsGuildIdInfractionsRouteImport } from './routes/guilds/$guildId/infractions'
import { Route as GuildsGuildIdAutomodRouteImport } from './routes/guilds/$guildId/automod'
import { Route as GuildsGuildIdAutomationsRouteImport } from './routes/guilds/$guildId/automations'
import { Route as GuildsGuildIdAutoRoleRouteImport } from './routes/guilds/$guildId/auto-role'
import { Route as GuildsGuildIdAuditRouteImport } from './routes/guilds/$guildId/audit'
import { Route as GuildsGuildIdApiKeysRouteImport } from './routes/guilds/$guildId/api-keys'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GuildsGuildIdIndexRoute = GuildsGuildIdIndexRouteImport.update({
  id: '/guilds/$guildId/',
  path: '/guilds/$guildId/',
  getParentRoute: () => rootRouteImport,
} as any)
const GuildsGuildIdWelcomeRoute = GuildsGuildIdWelcomeRouteImport.update({
  id: '/guilds/$guildId/welcome',
  path: '/guilds/$guildId/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const GuildsGuildIdSpamQueueRoute = GuildsGuildIdSpamQueueRouteImport.update({
  id: '/guilds/$guildId/spam-queue',
  path: '/guilds/$guildId/spam-queue',
  getParentRoute: () => rootRouteImport,
} as any)
const GuildsGuildIdSpamRoute = GuildsGuildIdSpamRouteImport.update({
  id: '/guilds/$guildId/spam',
  path: '/guilds/$guildId/spam',
  getParentRoute: () => rootRouteImport,
} as any)
const GuildsGuildIdReactionRolesRoute =
  GuildsGuildIdReactionRolesRouteImport.update({
    id: '/guilds/$guildId/reaction-roles',
    path: '/guilds/$guildId/reaction-roles',
    getParentRoute: () => rootRouteImport,
  } as any)
const GuildsGuildIdPurgeRoute = GuildsGuildIdPurgeRouteImport.update({
  id: '/guilds/$guildId/purge',
  path: '/guilds/$guildId/purge',
  getParentRoute: () => rootRouteImport,
} as any)
const GuildsGuildIdPollsRoute = GuildsGuildIdPollsRouteImport.update({
  id: '/guilds/$guildId/polls',
  path: '/guilds/$guildId/polls',
  getParentRoute: () => rootRouteImport,
} as any)
const GuildsGuildIdMembersRoute = GuildsGuildIdMembersRouteImport.update({
  id: '/guilds/$guildId/members',
  path: '/guilds/$guildId/members',
  getParentRoute: () => rootRouteImport,
} as any)
const GuildsGuildIdInfractionsRoute =
  GuildsGuildIdInfractionsRouteImport.update({
    id: '/guilds/$guildId/infractions',
    path: '/guilds/$guildId/infractions',
    getParentRoute: () => rootRouteImport,
  } as any)
const GuildsGuildIdAutomodRoute = GuildsGuildIdAutomodRouteImport.update({
  id: '/guilds/$guildId/automod',
  path: '/guilds/$guildId/automod',
  getParentRoute: () => rootRouteImport,
} as any)
const GuildsGuildIdAutomationsRoute =
  GuildsGuildIdAutomationsRouteImport.update({
    id: '/guilds/$guildId/automations',
    path: '/guilds/$guildId/automations',
    getParentRoute: () => rootRouteImport,
  } as any)
const GuildsGuildIdAutoRoleRoute = GuildsGuildIdAutoRoleRouteImport.update({
  id: '/guilds/$guildId/auto-role',
  path: '/guilds/$guildId/auto-role',
  getParentRoute: () => rootRouteImport,
} as any)
const GuildsGuildIdAuditRoute = GuildsGuildIdAuditRouteImport.update({
  id: '/guilds/$guildId/audit',
  path: '/guilds/$guildId/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const GuildsGuildIdApiKeysRoute = GuildsGuildIdApiKeysRouteImport.update({
  id: '/guilds/$guildId/api-keys',
  path: '/guilds/$guildId/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/guilds/$guildId/api-keys': typeof GuildsGuildIdApiKeysRoute
  '/guilds/$guildId/audit': typeof GuildsGuildIdAuditRoute
  '/guilds/$guildId/auto-role': typeof GuildsGuildIdAutoRoleRoute
  '/guilds/$guildId/automations': typeof GuildsGuildIdAutomationsRoute
  '/guilds/$guildId/automod': typeof GuildsGuildIdAutomodRoute
  '/guilds/$guildId/infractions': typeof GuildsGuildIdInfractionsRoute
  '/guilds/$guildId/members': typeof GuildsGuildIdMembersRoute
  '/guilds/$guildId/polls': typeof GuildsGuildIdPollsRoute
  '/guilds/$guildId/purge': typeof GuildsGuildIdPurgeRoute
  '/guilds/$guildId/reaction-roles': typeof GuildsGuildIdReactionRolesRoute
  '/guilds/$guildId/spam': typeof GuildsGuildIdSpamRoute
  '/guilds/$guildId/spam-queue': typeof GuildsGuildIdSpamQueueRoute
  '/guilds/$guildId/welcome': typeof GuildsGuildIdWelcomeRoute
  '/guilds/$guildId/': typeof GuildsGuildIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/guilds/$guildId/api-keys': typeof GuildsGuildIdApiKeysRoute
  '/guilds/$guildId/audit': typeof GuildsGuildIdAuditRoute
  '/guilds/$guildId/auto-role': typeof GuildsGuildIdAutoRoleRoute
  '/guilds/$guildId/automations': typeof GuildsGuildIdAutomationsRoute
  '/guilds/$guildId/automod': typeof GuildsGuildIdAutomodRoute
  '/guilds/$guildId/infractions': typeof GuildsGuildIdInfractionsRoute
  '/guilds/$guildId/members': typeof GuildsGuildIdMembersRoute
  '/guilds/$guildId/polls': typeof GuildsGuildIdPollsRoute
  '/guilds/$guildId/purge': typeof GuildsGuildIdPurgeRoute
  '/guilds/$guildId/reaction-roles': typeof GuildsGuildIdReactionRolesRoute
  '/guilds/$guildId/spam': typeof GuildsGuildIdSpamRoute
  '/guilds/$guildId/spam-queue': typeof GuildsGuildIdSpamQueueRoute
  '/guilds/$guildId/welcome': typeof GuildsGuildIdWelcomeRoute
  '/guilds/$guildId': typeof GuildsGuildIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/guilds/$guildId/api-keys': typeof GuildsGuildIdApiKeysRoute
  '/guilds/$guildId/audit': typeof GuildsGuildIdAuditRoute
  '/guilds/$guildId/auto-role': typeof GuildsGuildIdAutoRoleRoute
  '/guilds/$guildId/automations': typeof GuildsGuildIdAutomationsRoute
  '/guilds/$guildId/automod': typeof GuildsGuildIdAutomodRoute
  '/guilds/$guildId/infractions': typeof GuildsGuildIdInfractionsRoute
  '/guilds/$guildId/members': typeof GuildsGuildIdMembersRoute
  '/guilds/$guildId/polls': typeof GuildsGuildIdPollsRoute
  '/guilds/$guildId/purge': typeof GuildsGuildIdPurgeRoute
  '/guilds/$guildId/reaction-roles': typeof GuildsGuildIdReactionRolesRoute
  '/guilds/$guildId/spam': typeof GuildsGuildIdSpamRoute
  '/guilds/$guildId/spam-queue': typeof GuildsGuildIdSpamQueueRoute
  '/guilds/$guildId/welcome': typeof GuildsGuildIdWelcomeRoute
  '/guilds/$guildId/': typeof GuildsGuildIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/guilds/$guildId/api-keys'
    | '/guilds/$guildId/audit'
    | '/guilds/$guildId/auto-role'
    | '/guilds/$guildId/automations'
    | '/guilds/$guildId/automod'
    | '/guilds/$guildId/infractions'
    | '/guilds/$guildId/members'
    | '/guilds/$guildId/polls'
    | '/guilds/$guildId/purge'
    | '/guilds/$guildId/reaction-roles'
    | '/guilds/$guildId/spam'
    | '/guilds/$guildId/spam-queue'
    | '/guilds/$guildId/welcome'
    | '/guilds/$guildId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/login'
    | '/guilds/$guildId/api-keys'
    | '/guilds/$guildId/audit'
    | '/guilds/$guildId/auto-role'
    | '/guilds/$guildId/automations'
    | '/guilds/$guildId/automod'
    | '/guilds/$guildId/infractions'
    | '/guilds/$guildId/members'
    | '/guilds/$guildId/polls'
    | '/guilds/$guildId/purge'
    | '/guilds/$guildId/reaction-roles'
    | '/guilds/$guildId/spam'
    | '/guilds/$guildId/spam-queue'
    | '/guilds/$guildId/welcome'
    | '/guilds/$guildId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/login'
    | '/guilds/$guildId/api-keys'
    | '/guilds/$guildId/audit'
    | '/guilds/$guildId/auto-role'
    | '/guilds/$guildId/automations'
    | '/guilds/$guildId/automod'
    | '/guilds/$guildId/infractions'
    | '/guilds/$guildId/members'
    | '/guilds/$guildId/polls'
    | '/guilds/$guildId/purge'
    | '/guilds/$guildId/reaction-roles'
    | '/guilds/$guildId/spam'
    | '/guilds/$guildId/spam-queue'
    | '/guilds/$guildId/welcome'
    | '/guilds/$guildId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  LoginRoute: typeof LoginRoute
  GuildsGuildIdApiKeysRoute: typeof GuildsGuildIdApiKeysRoute
  GuildsGuildIdAuditRoute: typeof GuildsGuildIdAuditRoute
  GuildsGuildIdAutoRoleRoute: typeof GuildsGuildIdAutoRoleRoute
  GuildsGuildIdAutomationsRoute: typeof GuildsGuildIdAutomationsRoute
  GuildsGuildIdAutomodRoute: typeof GuildsGuildIdAutomodRoute
  GuildsGuildIdInfractionsRoute: typeof GuildsGuildIdInfractionsRoute
  GuildsGuildIdMembersRoute: typeof GuildsGuildIdMembersRoute
  GuildsGuildIdPollsRoute: typeof GuildsGuildIdPollsRoute
  GuildsGuildIdPurgeRoute: typeof GuildsGuildIdPurgeRoute
  GuildsGuildIdReactionRolesRoute: typeof GuildsGuildIdReactionRolesRoute
  GuildsGuildIdSpamRoute: typeof GuildsGuildIdSpamRoute
  GuildsGuildIdSpamQueueRoute: typeof GuildsGuildIdSpamQueueRoute
  GuildsGuildIdWelcomeRoute: typeof GuildsGuildIdWelcomeRoute
  GuildsGuildIdIndexRoute: typeof GuildsGuildIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/': {
      id: '/guilds/$guildId/'
      path: '/guilds/$guildId'
      fullPath: '/guilds/$guildId/'
      preLoaderRoute: typeof GuildsGuildIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/welcome': {
      id: '/guilds/$guildId/welcome'
      path: '/guilds/$guildId/welcome'
      fullPath: '/guilds/$guildId/welcome'
      preLoaderRoute: typeof GuildsGuildIdWelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/spam-queue': {
      id: '/guilds/$guildId/spam-queue'
      path: '/guilds/$guildId/spam-queue'
      fullPath: '/guilds/$guildId/spam-queue'
      preLoaderRoute: typeof GuildsGuildIdSpamQueueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/spam': {
      id: '/guilds/$guildId/spam'
      path: '/guilds/$guildId/spam'
      fullPath: '/guilds/$guildId/spam'
      preLoaderRoute: typeof GuildsGuildIdSpamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/reaction-roles': {
      id: '/guilds/$guildId/reaction-roles'
      path: '/guilds/$guildId/reaction-roles'
      fullPath: '/guilds/$guildId/reaction-roles'
      preLoaderRoute: typeof GuildsGuildIdReactionRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/purge': {
      id: '/guilds/$guildId/purge'
      path: '/guilds/$guildId/purge'
      fullPath: '/guilds/$guildId/purge'
      preLoaderRoute: typeof GuildsGuildIdPurgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/polls': {
      id: '/guilds/$guildId/polls'
      path: '/guilds/$guildId/polls'
      fullPath: '/guilds/$guildId/polls'
      preLoaderRoute: typeof GuildsGuildIdPollsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/members': {
      id: '/guilds/$guildId/members'
      path: '/guilds/$guildId/members'
      fullPath: '/guilds/$guildId/members'
      preLoaderRoute: typeof GuildsGuildIdMembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/infractions': {
      id: '/guilds/$guildId/infractions'
      path: '/guilds/$guildId/infractions'
      fullPath: '/guilds/$guildId/infractions'
      preLoaderRoute: typeof GuildsGuildIdInfractionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/automod': {
      id: '/guilds/$guildId/automod'
      path: '/guilds/$guildId/automod'
      fullPath: '/guilds/$guildId/automod'
      preLoaderRoute: typeof GuildsGuildIdAutomodRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/automations': {
      id: '/guilds/$guildId/automations'
      path: '/guilds/$guildId/automations'
      fullPath: '/guilds/$guildId/automations'
      preLoaderRoute: typeof GuildsGuildIdAutomationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/auto-role': {
      id: '/guilds/$guildId/auto-role'
      path: '/guilds/$guildId/auto-role'
      fullPath: '/guilds/$guildId/auto-role'
      preLoaderRoute: typeof GuildsGuildIdAutoRoleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/audit': {
      id: '/guilds/$guildId/audit'
      path: '/guilds/$guildId/audit'
      fullPath: '/guilds/$guildId/audit'
      preLoaderRoute: typeof GuildsGuildIdAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guilds/$guildId/api-keys': {
      id: '/guilds/$guildId/api-keys'
      path: '/guilds/$guildId/api-keys'
      fullPath: '/guilds/$guildId/api-keys'
      preLoaderRoute: typeof GuildsGuildIdApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  LoginRoute: LoginRoute,
  GuildsGuildIdApiKeysRoute: GuildsGuildIdApiKeysRoute,
  GuildsGuildIdAuditRoute: GuildsGuildIdAuditRoute,
  GuildsGuildIdAutoRoleRoute: GuildsGuildIdAutoRoleRoute,
  GuildsGuildIdAutomationsRoute: GuildsGuildIdAutomationsRoute,
  GuildsGuildIdAutomodRoute: GuildsGuildIdAutomodRoute,
  GuildsGuildIdInfractionsRoute: GuildsGuildIdInfractionsRoute,
  GuildsGuildIdMembersRoute: GuildsGuildIdMembersRoute,
  GuildsGuildIdPollsRoute: GuildsGuildIdPollsRoute,
  GuildsGuildIdPurgeRoute: GuildsGuildIdPurgeRoute,
  GuildsGuildIdReactionRolesRoute: GuildsGuildIdReactionRolesRoute,
  GuildsGuildIdSpamRoute: GuildsGuildIdSpamRoute,
  GuildsGuildIdSpamQueueRoute: GuildsGuildIdSpamQueueRoute,
  GuildsGuildIdWelcomeRoute: GuildsGuildIdWelcomeRoute,
  GuildsGuildIdIndexRoute: GuildsGuildIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
